export default __webpack_public_path__ + "9e8ba1b16e5c6373c0611eb0f7c10751.png";